import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { actions as userActions } from '../../actions/userActions';
import { actions as accountActions } from '../../actions/accountActions';
import { actions as subscriptionActions } from '../../actions/subscriptionActions';
import { actions as mfaActions } from '../../actions/mfaActions';
import { DEFAULT_PAGE_SIZE, MOBILE_WINDOW_BREAKPOINT, SortColumnsType } from '../../constants/constants';
import { CUSTOMER_ROLES } from '../../constants/roles';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Menu } from 'primereact/menu';
import UserProfileDrawer from '../User/UserProfileDrawer';
import InviteUserDrawer from '../InviteUser/InviteUserDrawer';
import ImportUsersDrawer from '../ImportUsers/ImportUsersDrawer';
import UserLocationsDrawer from '../User/UserLocationsDrawer';
import UserNotificationsDrawer from '../User/UserNotificationsDrawer';
import Icon from '../Common/Icon';
import Notification from '../../components/Common/Notification';
import Modal from '../Common/Modal/Modal';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import './SubscriptionUsers.scss';
import UserBulkLocationSearchDrawer from '../User/UserBulkLocationSearchDrawer';
import Moment from 'moment';
import { getDataTableSortFields, getSearchParamSortFields } from '../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../helpers/multiselect';
import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';

const COGMENUOPTIONS = {
	ViewProfile: 'viewProfile',
	ViewLocationAccess: 'viewLocationAccess',
	ViewEmailSettings: 'emailNotifications',
	SendForgotPassword: 'forgotPassword',
	ResendInvitation: 'resendInvitation',
	Reset2fa: 'reset2fa',
	Disable2fa: 'disable2fa',
};

const ACTION_MENU_OPTIONS = {
	ViewProfile: 'viewProfile',
	LocationAccess: 'locationAccess',
	EmailSettings: 'emailNotificationSettings',
	PasswordReset: 'emailPasswordReset',
	MakeActive: 'makeActive',
	MakeInactive: 'makeInactive',
	DeleteUser: 'deleteUser',
	ResendInvitation: 'resendInvitation',
	AllBaselines: 'allBaselines',
	Reset2fa: 'reset2fa',
	Disable2fa: 'disable2fa',
	ReassignTasks: 'reassignTasks',
};

// Filter inputs that search on blur / Enter rather than on change
const TEXT_FILTER_FIELDS = ['firstName', 'lastName', 'userName', 'email', 'ssoId'];

const DRAWERS = {
	InviteUser: 'inviteUser',
	ImportUsers: 'importUsers',
	UserProfile: 'userProfile',
	LocationAccess: 'locationAccess',
	BulkLocationSearch: 'bulkLocationSearch',
	EmailSettings: 'emailSettings',
};

export class SubscriptionUsersPage extends React.Component {
	constructor(props, context) {
		super(props, context);

		if (this.props.subscriptionId) {
			const newUser = {
				id: 0,
				subscriptionId: 0,
				firstName: '',
				lastName: '',
				userName: '',
				email: '',
				workPhone: '',
				roleId: '',
				countryId: 0,
				managementCompanyId: 0,
				communityIds: '',
				departmentIds: '',
				excludeAsProjectCoach: false,
				allowTaskListExportToExcel: false,
				allowLocationTaskDateChanges: false,
				ssoId: '',
				lastLoginDate: '',
				isActive: true,
				selectedUserLocationAccess: '',
				userLocationRules: {
					areas: '',
					brands: '',
					continents: '',
					countries: '',
					locationTypes: '',
					managementCompanies: '',
					regions: '',
				},
				is2faEnabled: false,
			};

			this.state = {
				users: [],
				totalCount: 0,
				columnOrder: [],
				selectedUser: newUser,
				editUser: newUser,
				newUser: newUser,
				isFetching: false,
				isSaving: false,
				searchParams: {
					subscriptionId: this.props.subscriptionId,
					isActive: true,
					firstName: '',
					lastName: '',
					userName: '',
					email: '',
					roleId: null,
					ssoId: '',
					pageSize: DEFAULT_PAGE_SIZE,
					pageNumber: 1,
					sortBy: 'firstName',
					sortDir: 'asc',
					returnAllResults: false,
					communityIds: [],
					locationAccessTypes: [],
				},
				// Location Access and Bulk Location Search can be open at the same time
				// So we have to track each drawer separately, but we control the logic
				// inside of this.openDrawer() and this.closeDrawer() so that these
				// variables remain mutually exclusive when required to
				openDrawers: {
					inviteUser: false,
					userProfile: false,
					locationAccess: false,
					bulkLocationSearch: false,
					emailSettings: false,
					importUsers: false,
				},
				addBulkLocationsFunc: () => {
					/*Do nothing*/
				},
				assignedLocations: [],
				showLocationAccessDrawerAfterSearch: false,
				selectUserAfterSearch: null,
				showAllBaselinesModal: false,
				communityFilterOptions: [],
				selectedCommunities: [],
				dropFilterChanged: false,
				selectedLocationAccess: [],
				locationDropFilterChanged: false,
				showReassignTasksModal: false,
				reassignMode: 'unassign', // 'unassign' or 'reassign'
				eligibleUsers: [],
				isLoadingEligibleUsers: false,
				selectedAssigneeUserId: null,
				taskCounts: { total: 0, locations: [] },
				isLoadingTaskInfo: false,
			};
			this.search.bind(this);
		}
	}

	openDrawer = (drawerKey) => {
		let openDrawers = {
			inviteUser: false,
			userProfile: false,
			locationAccess: false,
			bulkLocationSearch: false,
			emailSettings: false,
		};

		switch (drawerKey) {
			case DRAWERS.InviteUser:
				openDrawers.inviteUser = true;
				break;
			case DRAWERS.UserProfile:
				openDrawers.userProfile = true;
				break;
			case DRAWERS.LocationAccess:
				openDrawers.locationAccess = true;
				break;
			case DRAWERS.BulkLocationSearch:
				// Bulk Location Search is launched from Location Access, so we
				// leave both of them open
				openDrawers.locationAccess = true;
				openDrawers.bulkLocationSearch = true;
				break;
			case DRAWERS.EmailSettings:
				openDrawers.emailSettings = true;
				break;

			case DRAWERS.ImportUsers:
				openDrawers.importUsers = true;
				break;
			default:
				break;
		}

		this.setState({
			openDrawers: {
				...this.state.openDrawers,
				...openDrawers,
			},
			isFormValid: true,
		});
	};

	closeDrawer = (drawerKey) => {
		let openDrawers = {
			inviteUser: false,
			importUsers: false,
			userProfile: false,
			locationAccess: false,
			bulkLocationSearch: false,
			emailSettings: false,
		};

		switch (drawerKey) {
			case DRAWERS.BulkLocationSearch:
				// Bulk Location Search is launched from Location Access, so we
				// only close Bulk Location Search, but keep locationAccess open
				openDrawers.locationAccess = true;
				openDrawers.bulkLocationSearch = false;
				break;
			case DRAWERS.LocationAccess:
				openDrawers.locationAccess = false;
				break;
			case DRAWERS.UserProfile:
				openDrawers.userProfile = false;
				break;
			case DRAWERS.InviteUser:
				if (drawerKey === DRAWERS.UserProfile) {
					openDrawers.userProfile = false;
				} else {
					openDrawers.inviteUser = false;
				}
				break;
			case DRAWERS.EmailSettings:
				openDrawers.emailSettings = false;
				break;
			case DRAWERS.ImportUsers:
				openDrawers.importUsers = false;
				break;
			default:
				return;
		}

		this.setState({
			openDrawers: {
				...this.state.openDrawers,
				...openDrawers,
			},
		});
	};

	onImportUsersComplete = () => {
		this.closeDrawer(DRAWERS.ImportUsers);
		this.search();
	};

	onImportUsersCancel = () => {
		this.closeDrawer(DRAWERS.ImportUsers);
	};

	onInviteUserComplete = (showLocationAccessDrawer, newUserId) => {
		this.setState(
			{
				showLocationAccessDrawerAfterSearch: showLocationAccessDrawer,
				selectUserAfterSearch: newUserId,
			},
			() => {
				this.closeDrawer(DRAWERS.InviteUser);
				this.search();
			}
		);
	};

	onInviteUserCancel = () => {
		this.closeDrawer(DRAWERS.InviteUser);
	};

	onEditUserComplete = () => {
		this.closeDrawer(DRAWERS.UserProfile);
		this.search();
	};

	onEditUserCancel = () => {
		this.closeDrawer(DRAWERS.UserProfile);
	};

	onEditLocationsComplete = () => {
		this.setState({
			showLocationAccessDrawerAfterSearch: false,
			selectUserAfterSearch: null,
		});
		this.closeDrawer(DRAWERS.LocationAccess);
		this.search();
	};

	onEditLocationsCancel = () => {
		this.closeDrawer(DRAWERS.LocationAccess);
	};

	onBulkLocationSearchLaunch = (addBulkLocationsFunc, assignedLocations) => {
		this.setState({ addBulkLocationsFunc: addBulkLocationsFunc, assignedLocations: assignedLocations });
		this.openDrawer(DRAWERS.BulkLocationSearch);
	};

	onBulkLocationSearchComplete = (selectedLocations) => {
		this.closeDrawer(DRAWERS.BulkLocationSearch);
		this.state.addBulkLocationsFunc(selectedLocations);
	};

	onBulkLocationSearchCancel = () => {
		this.closeDrawer(DRAWERS.BulkLocationSearch);
	};

	onEmailSettingsComplete = () => {
		this.closeDrawer(DRAWERS.EmailSettings);
	};

	onEmailSettingsCancel = () => {
		this.closeDrawer(DRAWERS.EmailSettings);
	};

	async componentDidMount() {
		await this.search();
	}

	async search() {
		try {
			this.lastSearchedTextFilters = JSON.stringify(TEXT_FILTER_FIELDS.map((f) => this.state.searchParams[f]));
			this.setState({ isFetching: true });
			const result = await this.props.userActions.searchUsers(this.state.searchParams);
			const payload = result.payload;
			if (result.type === types.SEARCH_USER_SUCCESS) {
				let selectedUser = null;

				// After a user is invited and no location access was assigned to them
				// we need to select that user and open the location access drawer
				if (this.state.showLocationAccessDrawerAfterSearch && this.state.selectUserAfterSearch) {
					selectedUser = payload.results.find((m) => m.id == this.state.selectUserAfterSearch);
				}

				// Never null the selection out from under an open drawer - the drawers read
				// editUser.id as they render. Outside the post-invite flow, re-read the selected
				// user from the fresh results so a mutate-then-search (deactivate, role change)
				// is reflected in the cog menu instead of leaving stale values behind.
				const refreshedUser = selectedUser
					? selectedUser
					: this.state.editUser
						? payload.results.find((m) => m.id === this.state.editUser.id)
						: null;

				const selectionState = refreshedUser
					? { selectedUser: { ...this.state.newUser, ...refreshedUser }, editUser: { ...this.state.newUser, ...refreshedUser } }
					: {};

				// Update state with community filter options - now using the new structure with id and name
				const communityOptions = payload.communityFilterOptions
					? payload.communityFilterOptions.map((c) => ({ label: c.name, value: c }))
					: [];

				this.setState(
					{
						users: payload.results,
						totalCount: payload.totalCount,
						...selectionState,
						columnOrder: payload.columnOrder,
						communityFilterOptions: communityOptions,
					},
					() => {
						if (this.state.selectUserAfterSearch && selectedUser) {
							this.openDrawer(DRAWERS.LocationAccess);
						}
					}
				);
			} else if (result.type === types.SEARCH_USER_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	filterChange = (e) => {
		let name = e.target.name;
		this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
	};

	/**
	 * Applies a filter change and searches. Always returns to the first page: the results are
	 * paged server side, so keeping the old page number after narrowing the results reads past
	 * the end of the new result set and shows an empty grid alongside a non-zero total.
	 */
	applyFilter = (changedSearchParams, extraState = {}) => {
		this.setState(
			{
				...extraState,
				searchParams: { ...this.state.searchParams, ...changedSearchParams, pageNumber: 1 },
			},
			() => {
				this.search();
			}
		);
	};

	/**
	 * The text filters search on blur, and every text input is wired to it - so a user who merely
	 * clicks into a box and back out must not be re-searched and thrown back to page 1.
	 */
	applyTextFilters = () => {
		const current = JSON.stringify(TEXT_FILTER_FIELDS.map((f) => this.state.searchParams[f]));

		if (current === this.lastSearchedTextFilters) return;

		this.applyFilter({});
	};

	onSearchBlur = () => {
		this.applyTextFilters();
	};

	keyUpFilter = (e) => {
		if (e.keyCode == 13) {
			this.applyTextFilters();
		}
	};

	selectUserRow = (e) => {
		const isEllipsisClick =
			e.originalEvent.target.className.indexOf('ellipsis-h') >= 0 || e.originalEvent.target.className.indexOf('ellipsis') >= 0;
		if (isEllipsisClick === true) {
			return;
		}

		// fires when user clicks a row in the datatable, but only on mobile do we show the menu
		// non mobile they need to click the actions button which calls onActionsClick
		if (this.state.windowWidth < MOBILE_WINDOW_BREAKPOINT) {
			this.setSelectedUser(e.value);
			this.menu.toggle(e.originalEvent);
		} else {
			this.onNameClick(e.value);
		}
	};

	onActionsClick = (rowData, e) => {
		this.setSelectedUser(rowData);
		this.menu.toggle(e);
	};

	setSelectedUser = (user) => {
		const newUser = { ...this.state.newUser, ...user };
		this.setState({ selectedUser: newUser, editUser: newUser });
	};

	onActiveFilterChange = (e) => {
		const selectedValue = getNullableOnChangeValue(e);

		this.applyFilter({ isActive: selectedValue });
	};

	onRoleFilterChange = (e) => {
		const selectedValue = getNullableOnChangeValue(e);

		this.applyFilter({ roleId: selectedValue });
	};

	handleCommunityMultiSelectChange = (e) => {
		const selectedValues = e.value || [];
		this.setState({
			selectedCommunities: selectedValues,
			dropFilterChanged: true,
		});
	};

	handleCommunityMultiSelectClose = () => {
		if (this.state.dropFilterChanged === true) {
			// Update search params with community IDs when the dropdown closes
			const communityIds = this.state.selectedCommunities.map((c) => c.id);
			this.applyFilter({ communityIds: communityIds }, { dropFilterChanged: false });
		}
	};

	selectedCommunityTemplate = (community) => {
		// The multiselect value is the raw community ({ id, name }), which has no `label` field for
		// PrimeReact to fall back on when the option list no longer contains it, so render the name
		// ourselves instead of letting the label resolve to undefined.
		if (!community) return null;

		return <span>{community.name}</span>;
	};

	customCloseIcon = () => {
		return (
			<i
				className={classNames('pi', {
					'pi-times': !this.state?.dropFilterChanged,
					'pi-check-square text-success': this.state?.dropFilterChanged,
				})}
			/>
		);
	};

	onNameClick = (rowData) => {
		this.setSelectedUser(rowData);
		this.openDrawer(DRAWERS.UserProfile);
	};

	activeTemplate = (rowData) => {
		/**
		 * 1509: This cannot be a div, because the block display of a div pushes the wrapping
		 * .ui-cell-data span up, triggering a y-axis overflow of the table cell, which causes
		 * a scrollbar to show always.  Spans are inline-block by default, and we then center
		 * the icons in the box via the .center-inline-block class, which centers via 33% left
		 * and right margins.
		 */
		if (rowData.isActive) {
			return (
				<span className='text-success center-inline-block'>
					<Icon name='check-circle' />
				</span>
			);
		} else {
			return (
				<span className='text-danger center-inline-block'>
					<Icon name='times-circle' />
				</span>
			);
		}
	};

	actionTemplate = (rowData) => {
		return (
			<div className='text-center ellipsis' onClick={(e) => this.onActionsClick(rowData, e)} data-testid="user-actions-button">
				<Icon name='ellipsis-h' />
			</div>
		);
	};

	dateTimeTemplate = (rowData) => {
		return rowData.lastLoginDateTime ? Moment(rowData.lastLoginDateTime).format('MM-DD-YYYY, h:mm A') : 'N/A';
	};

	firstNameTemplate = (rowData) => {
		return (
			<span className='datatable-link' onClick={() => this.onNameClick(rowData)}>
				{rowData.firstName}
			</span>
		);
	};

	lastNameTemplate = (rowData) => {
		return (
			<span className='datatable-link' onClick={() => this.onNameClick(rowData)}>
				{rowData.lastName}
			</span>
		);
	};

	communitiesTemplate = (rowData) => {
		// Return null rather than letting the && chain evaluate to `false`, which the DataTable
		// renders as the literal text "false" for a user with no communities.
		if (!rowData.communities || rowData.communities.length === 0) return null;

		return rowData.communities.map((item, key) => {
			return (
				<React.Fragment key={key}>
					{item}
					<br />
				</React.Fragment>
			);
		});
	};

	locationsTemplate = (rowData) => {
		// Show a different icon depending on the user's location access
		let icon = '';

		if (rowData.grantAccessToAllLocations === undefined || rowData.grantAccessToAllLocations === null) {
			icon = <i className='fa-solid fa-location-pin-lock' title='Based on rule'></i>;
		} else if (rowData.grantAccessToAllLocations === true) {
			icon = <i className='fa-solid fa-location-check' title='All locations'></i>;
		} else if (rowData.grantAccessToAllLocations === false) {
			if (rowData.locations && rowData.locations.length > 0) {
				if (rowData.locations.length === 1) {
					icon = <i className='fa-solid fa-location-dot' title={rowData.locations[0]}></i>;
				} else {
					icon = <i className='fa-solid fa-location-plus' title={`${rowData.locations.length} locations`}></i>;
				}
			} else {
				icon = <i className='fa-solid fa-location-dot-slash' title='No locations'></i>;
			}
		}

		return <div className='text-center'>{icon}</div>;
	};

	cogMenuClick = (e) => {
		switch (e.item.value) {
			case COGMENUOPTIONS.ViewProfile:
				this.openDrawer(DRAWERS.UserProfile);
				break;
			case COGMENUOPTIONS.ViewLocationAccess:
				this.openDrawer(DRAWERS.LocationAccess);
				break;
			case COGMENUOPTIONS.ViewEmailSettings:
				this.openDrawer(DRAWERS.EmailSettings);
				break;
			case COGMENUOPTIONS.ResendInvitation:
				this.resendInvite();
				break;
			case COGMENUOPTIONS.SendForgotPassword:
				this.sendForgotPasswordEmail();
				break;
			case COGMENUOPTIONS.Reset2fa:
				this.reset2fa();
				break;
			case COGMENUOPTIONS.Disable2fa:
				this.disable2fa();
				break;
			default:
				break;
		}
	};

	sendForgotPasswordEmail = async () => {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.accountActions.forgotPassword(this.state.editUser.userName);
			const payload = result.payload;
			if (result.type === types.FORGOT_PASSWORD_SUCCESS) {
				Notification('success', 'Success', 'Forgot Password Email Sent Successfully');
			} else {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	resendInvite = async () => {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.subscriptionActions.getInviteMessage(this.props.subscriptionId);
			const payload = result.payload;
			if (result.type === types.GET_SUBSCRIPTION_INVITEMESSAGE_SUCCESS) {
				const jsonContent = JSON.parse(payload.inviteMessage);
				const contentState = convertFromRaw(jsonContent);
				const inviteMessageHTML = stateToHTML(contentState);
				const inviteResponse = await this.props.userActions.reinviteUser(this.state.editUser.id, inviteMessageHTML);
				if (inviteResponse.type === types.INVITE_USER_SUCCESS) {
					Notification('success', 'Success', 'Invitation Sent Successfully');
				} else {
					Notification('error', 'An Error Occurred sending invitation', payload.message);
				}
			} else if (result.type === types.GET_SUBSCRIPTION_INVITEMESSAGE_FAILURE) {
				Notification('error', 'An Error Occurred getting invite message', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	updateIsActive = async (active) => {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.userActions.updateIsActive(this.state.editUser.id, active);
			const payload = result.payload;
			if (result.type === types.UPDATE_USER_ISACTIVE_SUCCESS) {
				Notification('success', 'Success', 'User updated successfully');
				this.search();
			} else if (result.type === types.UPDATE_USER_ISACTIVE_FAILURE) {
				Notification('error', 'An Error Occurred getting invite message', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	reset2fa = async () => {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.mfaActions.reset(this.state.editUser.userName);
			const payload = result.payload;
			if (result.type === types.MFA_RESET_SUCCESS) {
				Notification('success', 'Success', 'Two Factor Authentication has been reset');
			} else if (result.type === types.MFA_RESET_FAILURE) {
				Notification('error', 'An Error Occurred resetting Two Factor Authentication', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	disable2fa = async () => {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.mfaActions.disable(this.state.editUser.userName);
			const payload = result.payload;
			if (result.type === types.MFA_DISABLE_SUCCESS) {
				this.setState({ editUser: { ...this.state.editUser, is2faEnabled: false } });
				Notification('success', 'Success', 'Two Factor Authentication has been disabled');
			} else if (result.type === types.MFA_DISABLE_FAILURE) {
				Notification('error', 'An Error Occurred disabling Two Factor Authentication', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	menuOptionClick = (e) => {
		switch (e.item.value) {
			case ACTION_MENU_OPTIONS.ViewProfile:
				this.openDrawer(DRAWERS.UserProfile);
				break;
			case ACTION_MENU_OPTIONS.LocationAccess:
				this.openDrawer(DRAWERS.LocationAccess);
				break;
			case ACTION_MENU_OPTIONS.PasswordReset:
				this.sendForgotPasswordEmail();
				break;
			case ACTION_MENU_OPTIONS.ResendInvitation:
				this.resendInvite();
				break;
			case ACTION_MENU_OPTIONS.EmailSettings:
				this.openDrawer(DRAWERS.EmailSettings);
				break;
			case ACTION_MENU_OPTIONS.MakeActive:
				this.updateIsActive(true);
				break;
			case ACTION_MENU_OPTIONS.MakeInactive:
				this.updateIsActive(false);
				break;
			case ACTION_MENU_OPTIONS.AllBaselines:
				this.setState({ showAllBaselinesModal: true });
				break;
			case ACTION_MENU_OPTIONS.Reset2fa:
				this.reset2fa();
				break;
			case ACTION_MENU_OPTIONS.Disable2fa:
				this.disable2fa();
				break;
			case ACTION_MENU_OPTIONS.ReassignTasks:
				this.showReassignTasksModal();
				break;
			default:
				break;
		}
	};

	onCogSettingsClick = (e) => {
		this.cogmenu.toggle(e);
	};

	allBaselinesOk = async () => {
		this.setState({ showAllBaselinesModal: false });
		try {
			this.setState({ isFetching: true });
			const result = await this.props.userActions.grantAccessToAllBaselines(this.state.editUser.id);
			const payload = result.payload;
			if (result.type === types.GRANT_USER_ALL_BASELINES_SUCCESS) {
				Notification(
					'success',
					'',
					'User had access to ' +
						payload.currentBaselines +
						' baselines and has been granted access to ' +
						payload.newBaselines +
						' additional baselines.'
				);
			} else if (result.type === types.GRANT_USER_ALL_BASELINES_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	};

	allBaselinesCancel = () => {
		this.setState({ showAllBaselinesModal: false });
	};

	showReassignTasksModal = async () => {
		try {
			this.setState({ isLoadingTaskInfo: true, showReassignTasksModal: true });
			
			// Get task counts and location information
			const result = await this.props.userActions.getUserTaskInfo(this.state.editUser.id);
			const payload = result.payload;
			
			// Guard: Only update state if modal is still open
			if (!this.state.showReassignTasksModal) {
				return;
			}
			
			if (result.type === types.GET_USER_TASK_INFO_SUCCESS) {
				this.setState({
					taskCounts: payload.taskCounts,
				});
			} else {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			// Guard: Only update loading state if modal is still open
			if (this.state.showReassignTasksModal) {
				this.setState({ isLoadingTaskInfo: false });
			}
		}
	};

	onReassignModeChange = (mode) => {
		this.setState({ 
			reassignMode: mode,
			selectedAssigneeUserId: null,
			eligibleUsers: [],
			isLoadingEligibleUsers: mode === 'reassign',
		});
		
		if (mode === 'reassign') {
			this.loadEligibleUsers();
		}
	};

	getSelectedAssigneeUserId = (value) => {
		if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
			return null;
		}

		const rawValue =
			typeof value === 'object'
				? value.id ?? value.value ?? value.userId ?? value
				: value;

		if (rawValue === null || rawValue === undefined || rawValue === '') {
			return null;
		}

		const numericValue = Number(rawValue);
		if (Number.isFinite(numericValue) && numericValue > 0) {
			return numericValue;
		}

		if (typeof rawValue === 'string') {
			const trimmedValue = rawValue.trim();
			return trimmedValue.length > 0 ? trimmedValue : null;
		}

		return null;
	};

	loadEligibleUsers = async () => {
		try {
			this.setState({ isLoadingEligibleUsers: true });
			const result = await this.props.userActions.getEligibleUsersForTaskReassignment(
				this.state.editUser.id,
				this.props.subscriptionId
			);
			const payload = result.payload;
			
			// Guard: Only update state if modal is still open and still in reassign mode
			if (!this.state.showReassignTasksModal || this.state.reassignMode !== 'reassign') {
				return;
			}
			
			if (result.type === types.GET_ELIGIBLE_USERS_FOR_REASSIGNMENT_SUCCESS) {
				this.setState({ 
					eligibleUsers: payload.eligibleUsers
				});
			} else {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			if (this.state.showReassignTasksModal && this.state.reassignMode === 'reassign') {
				this.setState({ isLoadingEligibleUsers: false });
			}
		}
	};

	onReassignTasksConfirm = async () => {
		try {
			// Validation: Check if reassign mode but no user selected
			if (this.state.reassignMode === 'reassign' && !this.state.selectedAssigneeUserId) {
				Notification('error', 'Validation Error', 'Please select a user to assign the tasks to.');
				return;
			}

			this.setState({ isSaving: true });
			
			let result;
			if (this.state.reassignMode === 'unassign') {
				result = await this.props.userActions.unassignUserTasks(this.state.editUser.id);
			} else {
				result = await this.props.userActions.reassignUserTasks(
					this.state.editUser.id, 
					this.state.selectedAssigneeUserId
				);
			}
			
			const payload = result.payload;
			
			if (result.type === types.REASSIGN_USER_TASKS_SUCCESS || result.type === types.UNASSIGN_USER_TASKS_SUCCESS) {
				const action = this.state.reassignMode === 'unassign' ? 'unassigned' : 'reassigned';
				Notification('success', 'Success', `Successfully ${action} ${payload.tasksAffected} tasks`);
				this.onReassignTasksCancel();
			} else {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	onReassignTasksCancel = () => {
		this.setState({ 
			showReassignTasksModal: false,
			reassignMode: 'unassign',
			eligibleUsers: [],
			isLoadingEligibleUsers: false,
			selectedAssigneeUserId: null,
			taskCounts: { total: 0, locations: [] }
		});
	};

	renderReassignTasksModalBody = () => {
		const { taskCounts, reassignMode, eligibleUsers, selectedAssigneeUserId, isLoadingTaskInfo, isLoadingEligibleUsers } = this.state;
		const { editUser } = this.state;

		return (
			<div className="reassign-tasks-modal">
				{isLoadingTaskInfo ? (
					<div>Loading task information...</div>
				) : (
					<div>
						<div className="user-info">
							<strong>User:</strong> {editUser.firstName} {editUser.lastName} ({editUser.email})
						</div>
						
						<div className="task-info">
							<strong>Active Tasks:</strong> {taskCounts.total}
							{taskCounts.locations && taskCounts.locations.length > 0 && (
								<div className="location-breakdown">
									<strong>Locations involved:</strong>
									<ul>
										{taskCounts.locations.map((loc, index) => (
											<li key={index}>
												{loc.locationName} ({loc.taskCount} tasks)
											</li>
										))}
									</ul>
								</div>
							)}
						</div>

						<div className="reassign-mode-selection">
							<div className="form-group">
								<label>
									<input
										type="radio"
										value="unassign"
										checked={reassignMode === 'unassign'}
										onChange={() => this.onReassignModeChange('unassign')}
									/>
									<span className="ms-2">Unassign tasks (remove assignment)</span>
								</label>
							</div>
							<div className="form-group">
								<label>
									<input
										type="radio"
										value="reassign"
										checked={reassignMode === 'reassign'}
										onChange={() => this.onReassignModeChange('reassign')}
									/>
									<span className="ms-2">Reassign tasks to another user</span>
								</label>
							</div>
						</div>

						{reassignMode === 'reassign' && (
							<div className="assignee-selection">
								{isLoadingEligibleUsers ? (
									<div className="form-group">
										<label><strong>Select user to assign tasks to:</strong></label>
										<div className="d-flex align-items-center">
											<div className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
											<span>Loading eligible users...</span>
										</div>
									</div>
								) : (
									<>
										<div className="form-group">
											<MultiSelectBox
												name="assigneeUser"
												idField="id"
												valueField="name"
												label="Select user to assign tasks to"
												options={eligibleUsers.map((user) => ({
													id: user.id,
													name: `${user.firstName} ${user.lastName} (${user.email})`,
												}))}
												selectedValues={selectedAssigneeUserId !== null ? String(selectedAssigneeUserId) : ''}
												onChange={(value) => this.setState({ selectedAssigneeUserId: this.getSelectedAssigneeUserId(value) })}
												isRequired={false}
												errorMessage=""
												isMulti={false}
												placeholder={eligibleUsers.length === 0 ? 'No eligible users found' : 'Select a user'}
												isDisabled={eligibleUsers.length === 0}
											/>
										</div>
										{eligibleUsers.length === 0 && (
											<div className="text-warning">
												<small>
													No users found who have access to all locations where this user has assigned tasks.
												</small>
											</div>
										)}
									</>
								)}
							</div>
						)}

						<div className="warning-text">
							<small className="text-muted">
								<strong>Note:</strong> Only active tasks that are not in &quot;N/A&quot; or &quot;Complete&quot; status will be affected.
								Tasks in inactive locations or inactive location tasks will be skipped.
							</small>
						</div>
					</div>
				)}
			</div>
		);
	};

	buildCogMenuOptions = () => {
		let cogMenuOptions = [];

		if (this.state.editUser && this.state.editUser.isSSOEnabled === false) {
			cogMenuOptions.push({ label: 'Email Password Reset', value: COGMENUOPTIONS.SendForgotPassword, command: this.cogMenuClick });
			cogMenuOptions.push({ label: 'Reset Two Factor Authentication', value: COGMENUOPTIONS.Reset2fa, command: this.cogMenuClick });

			if (this.state.editUser.is2faEnabled === true) {
				cogMenuOptions.push({ label: 'Disable Two Factor Authentication', value: COGMENUOPTIONS.Disable2fa, command: this.cogMenuClick });
			}
		}

		if (!this.state.openDrawers.userProfile) {
			cogMenuOptions.unshift({ label: 'View Profile', value: COGMENUOPTIONS.ViewProfile, command: this.cogMenuClick });
		}

		if (!this.state.openDrawers.locationAccess) {
			cogMenuOptions.unshift({ label: 'View Location Access', value: COGMENUOPTIONS.ViewLocationAccess, command: this.cogMenuClick });
		}

		if (!this.state.openDrawers.emailSettings) {
			cogMenuOptions.unshift({
				label: 'View Email Notification Settings',
				value: COGMENUOPTIONS.ViewEmailSettings,
				command: this.cogMenuClick,
			});
		}

		if (this.state.editUser && this.state.editUser.hasAcceptedInvite === false) {
			cogMenuOptions.push({ label: 'Resend Invitation', value: COGMENUOPTIONS.ResendInvitation, command: this.cogMenuClick });
		}

		return cogMenuOptions;
	};

	buildActionsMenuOptions = () => {
		const menuOptions = [
			{ label: 'View Profile', value: ACTION_MENU_OPTIONS.ViewProfile, command: this.menuOptionClick },
			{ label: 'Location Access', value: ACTION_MENU_OPTIONS.LocationAccess, command: this.menuOptionClick },
			{ label: 'Email Notification Settings', value: ACTION_MENU_OPTIONS.EmailSettings, command: this.menuOptionClick },
			{ label: 'Reassign Tasks', value: ACTION_MENU_OPTIONS.ReassignTasks, command: this.menuOptionClick },
		];

		if (this.state.editUser && this.state.editUser.isActive) {
			menuOptions.push({ label: 'Change to inactive user', value: ACTION_MENU_OPTIONS.MakeInactive, command: this.menuOptionClick });
		}

		if (this.state.editUser && !this.state.editUser.isActive) {
			menuOptions.push({ label: 'Change to active user', value: ACTION_MENU_OPTIONS.MakeActive, command: this.menuOptionClick });
		}

		if (this.state.editUser && this.state.editUser.hasAcceptedInvite === false) {
			menuOptions.push({ label: 'Resend Invitation', value: ACTION_MENU_OPTIONS.ResendInvitation, command: this.menuOptionClick });
		}

		if (this.state.editUser && this.state.editUser.isSSOEnabled === false) {
			menuOptions.push({ label: 'Email Password Reset', value: ACTION_MENU_OPTIONS.PasswordReset, command: this.menuOptionClick });
			menuOptions.push({ label: 'Reset Two Factor Authentication', value: ACTION_MENU_OPTIONS.Reset2fa, command: this.menuOptionClick });

			if (this.state.editUser.is2faEnabled === true) {
				menuOptions.push({
					label: 'Disable Two Factor Authentication',
					value: ACTION_MENU_OPTIONS.Disable2fa,
					command: this.menuOptionClick,
				});
			}
		}

		if (
			this.state.editUser &&
			(this.state.editUser.roleId === CUSTOMER_ROLES.Moderator.id ||
				this.state.editUser.roleId === CUSTOMER_ROLES.Admin.id ||
				this.state.editUser.roleId === CUSTOMER_ROLES.Owner.id)
		) {
			menuOptions.push({ label: 'Grant access to all Baselines', value: ACTION_MENU_OPTIONS.AllBaselines, command: this.menuOptionClick });
		}

		return menuOptions;
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	onSort = ({ sortField, sortOrder }) => {
		const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
		if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
			this.setState(
				{
					searchParams: {
						...this.state.searchParams,
						sortBy: sortBy,
						sortDir: sortDir,
					},
				},
				this.search
			);
		}
	};

	onColumnReorder = async (e) => {
		const newColumns = e.columns.map((c) => c.props.field);
		await this.props.userActions.saveUsersColumns({ columns: newColumns, columnsType: SortColumnsType.AdminPageSubscriptionUsers });
	};

	// Add handler methods for location access filter
	handleLocationAccessMultiSelectChange = (e) => {
		const selectedValues = e.value || [];
		this.setState({
			selectedLocationAccess: selectedValues,
			locationDropFilterChanged: true,
		});
	};

	handleLocationAccessMultiSelectClose = () => {
		if (this.state.locationDropFilterChanged === true) {
			// Update search params with location access types when the dropdown closes
			const locationAccessTypes = this.state.selectedLocationAccess.map((l) => l.value || l);
			this.applyFilter({ locationAccessTypes: locationAccessTypes }, { locationDropFilterChanged: false });
		}
	};

	customLocationCloseIcon = () => {
		return (
			<i
				className={classNames('pi', {
					'pi-times': !this.state?.locationDropFilterChanged,
					'pi-check-square text-success': this.state?.locationDropFilterChanged,
				})}
			/>
		);
	};

	selectedLocationTemplate = (option) => {
		
		if (!option) return null;
		
		const capitalizedValue = option.charAt(0).toUpperCase() + option.slice(1);
		
		return (
			<span>
				{capitalizedValue}
			</span>
		);
	};

	render() {
		const displayColumns = this.props.windowWidth < 500 ? 'none' : '';
		const activeOptions = [
			{ label: 'Yes', value: true },
			{ label: 'No', value: false },
			{ label: 'All', value: null },
		];
		const roleOptions = [
			{ label: 'All', value: null },
			{ label: CUSTOMER_ROLES.User.name, value: CUSTOMER_ROLES.User.id },
			{ label: CUSTOMER_ROLES.Moderator.name, value: CUSTOMER_ROLES.Moderator.id },
			{ label: CUSTOMER_ROLES.Admin.name, value: CUSTOMER_ROLES.Admin.id },
			{ label: CUSTOMER_ROLES.Owner.name, value: CUSTOMER_ROLES.Owner.id },
		];

		const locationAccessOptions = [
			{
				label: (
					<>
						<i className='fa-solid fa-location-check' title='All locations'></i> All locations
					</>
				),
				value: 'all',
				icon: 'fa-solid fa-location-check',
			},
			{
				label: (
					<>
						<i className='fa-solid fa-location-dot' title='Single location'></i> Single location
					</>
				),
				value: 'single',
				icon: 'fa-solid fa-location-dot',
			},
			{
				label: (
					<>
						<i className='fa-solid fa-location-plus' title='Multiple locations'></i> Multiple locations
					</>
				),
				value: 'multiple',
				icon: 'fa-solid fa-location-plus',
			},
			{
				label: (
					<>
						<i className='fa-solid fa-location-pin-lock' title='Access based on rule'></i> Based on rule
					</>
				),
				value: 'rule',
				icon: 'fa-solid fa-location-pin-lock',
			},
			{
				label: (
					<>
						<i className='fa-solid fa-location-dot-slash' title='No locations'></i> No access
					</>
				),
				value: 'none',
				icon: 'fa-solid fa-location-dot-slash',
			},
		];

		const menuOptions = this.buildActionsMenuOptions();

		const activeFilter = (
			<Dropdown
				name='isActive'
				value={this.state.searchParams.isActive}
				options={activeOptions}
				optionLabel='label'
				optionValue='value'
				onChange={this.onActiveFilterChange}
				placeholder='Select an option'
			/>
		);
		const roleidFilter = (
			<Dropdown
				appendTo={document.body}
				name='roleId'
				value={this.state.searchParams.roleId}
				options={roleOptions}
				optionLabel='label'
				optionValue='value'
				onChange={this.onRoleFilterChange}
			/>
		);

		const communityFilter = (
			<MultiSelect
				value={this.state.selectedCommunities}
				onChange={this.handleCommunityMultiSelectChange}
				onHide={this.handleCommunityMultiSelectClose}
				optionLabel='label'
				dataKey='id'
				style={{ width: '100%' }}
				options={this.state.communityFilterOptions}
				placeholder='Filter'
				closeIcon={this.customCloseIcon()}
				maxSelectedLabels={1}
				selectedItemTemplate={this.selectedCommunityTemplate}
			/>
		);

		const locationAccessFilter = (
			<MultiSelect
				value={this.state.selectedLocationAccess}
				onChange={this.handleLocationAccessMultiSelectChange}
				onHide={this.handleLocationAccessMultiSelectClose}
				optionLabel='label'
				dataKey='value'
				style={{ width: '100%' }}
				options={locationAccessOptions}
				placeholder='Filter'
				closeIcon={this.customLocationCloseIcon()}
				maxSelectedLabels={1}
				selectedItemTemplate={this.selectedLocationTemplate}
			/>
		);

		const firstNameFilter = (
			<input
				type='text'
				name='firstName'
				placeholder='First Name'
				className='p-inputtext'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.firstName}
			/>
		);
		const lastNameFilter = (
			<input
				type='text'
				name='lastName'
				placeholder='Last Name'
				className='p-inputtext'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.lastName}
			/>
		);
		const userNameFilter = (
			<input
				type='text'
				name='userName'
				placeholder='Username'
				className='p-inputtext'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.userName}
			/>
		);
		const emailFilter = (
			<input
				type='text'
				name='email'
				placeholder='Email'
				className='p-inputtext'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.email}
			/>
		);
		const ssoidFilter = (
			<input
				type='text'
				name='ssoId'
				placeholder='SSO ID'
				className='p-inputtext'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.ssoId}
			/>
		);

		const cogMenuOptions = this.buildCogMenuOptions();

		const cogMenuButtons = [
			<button key='settings' name='settings' type='button' className='btn btn-custom' onClick={this.onCogSettingsClick} alt='config'>
				<Icon name='cog' />
			</button>,
		];

		const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);
		const mobileColWidth = !displayColumns ? {} : { width: '25%' };

		const getStaticColumns = () => {
			return [
				{
					field: 'firstName',
					header: 'First Name',
					body: this.firstNameTemplate,
					filter: true,
					style: mobileColWidth,
					filterElement: firstNameFilter,
					isSortable: true,
				},
				{
					field: 'lastName',
					header: 'Last Name',
					body: this.lastNameTemplate,
					filter: true,
					style: mobileColWidth,
					filterElement: lastNameFilter,
					isSortable: true,
				},
				{
					field: 'userName',
					header: 'Username',
					filter: true,
					filterElement: userNameFilter,
					style: { display: displayColumns, textOverflow: 'ellipsis' },
					isSortable: true,
				},
				{
					field: 'email',
					header: 'Email',
					filter: true,
					filterElement: emailFilter,
					style: { display: displayColumns, textOverflow: 'ellipsis' },
					isSortable: true,
				},
				{
					field: 'lastLoginDateTime',
					header: 'Last Login',
					body: this.dateTimeTemplate,
					style: { display: displayColumns },
					isSortable: true,
				},
				{
					field: 'roleName',
					header: 'User Role',
					filter: true,
					filterElement: roleidFilter,
					style: { display: displayColumns },
					isSortable: true,
				},
				{
					field: 'ssoId',
					header: 'SSO Id',
					filter: true,
					filterElement: ssoidFilter,
					style: { display: displayColumns },
					isSortable: true,
				},
				{
					field: 'isActive',
					header: 'Active',
					body: this.activeTemplate,
					filter: true,
					filterElement: activeFilter,
					isSortable: true,
				},
				{
					field: 'communities',
					header: 'Communities',
					body: this.communitiesTemplate,
					filter: true,
					filterElement: communityFilter,
				},
				{
					field: 'locations',
					header: 'Locations',
					body: this.locationsTemplate,
					filter: true,
					filterElement: locationAccessFilter,
				},
				{
					field: 'actions',
					header: 'Actions',
					body: this.actionTemplate,
					style: { width: '6em' },
				},
			];
		};

		const buildColumnOptions = () => {
			const allColumns = getStaticColumns();
			const orderedColumns = [];

			if (Array.isArray(this.state.columnOrder) && this.state.columnOrder.length > 0) {
				for (const field of this.state.columnOrder) {
					const col = allColumns.find((c) => c.field === field);
					if (col) {
						orderedColumns.push(col);
					}
				}
			}

			if (orderedColumns.length === 0) {
				orderedColumns.push(...allColumns);
			}

			return orderedColumns.map((col) => (
				<Column
					key={col.field}
					field={col.field}
					header={col.header}
					body={col.body}
					filter={col.filter}
					style={col.style}
					filterElement={col.filterElement}
					sortable={col.isSortable}
				/>
			));
		};

		return (
			<div>
				<Menu model={menuOptions} popup={true} ref={(el) => (this.menu = el)} autoZIndex={false} baseZIndex={20001} />
				<Menu model={cogMenuOptions} popup={true} ref={(el) => (this.cogmenu = el)} autoZIndex={false} baseZIndex={20001} />
				<LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
					<div className='subscription-users-page' data-testid='subscription-users-page'>
						{this.props.isSubPage ? (
							<div className='subpage-header'>
								<div className='identifier-header'>
									<div className='title'>Users</div>
									<div className='close'>
										<button type='button' onClick={this.props.onClose} alt='close popup'>
											<Icon name='times' />
										</button>
									</div>
								</div>

								<div className='identifier-add-new'>
									<div className='col-sm-12'>
										<button
											type='button'
											className='btn btn-primary'
											onClick={() => this.openDrawer(DRAWERS.InviteUser)}
											alt='Invite User'>
											<span className='me-2'>Invite User</span>
											<Icon name='user-plus' />
										</button>
										<button
											type='button'
											className='btn btn-primary import-users-button'
											onClick={() => this.openDrawer(DRAWERS.ImportUsers)}
											alt='Invite User'>
											<span className='me-2'>Import Users</span>
											<Icon name='user-plus' />
										</button>
									</div>
								</div>
							</div>
						) : (
							<div className='page-header'>
								<h4 className='align-middle'>Users</h4>
								<button
									type='button'
									className='btn btn-primary'
									onClick={() => this.openDrawer(DRAWERS.InviteUser)}
									alt='Invite User'>
									<span className='me-2'>Invite User</span>
									<Icon name='user-plus' />
								</button>
							</div>
						)}
						<div className='subusers-results-table'>
							<DataTable
								filterDisplay='row'
								className='p-datatable-sm p-datatable-striped'
								value={this.state.users}
								resizableColumns
								columnResizeMode='fit'
								selectionMode='single'
								reorderableColumns
								onColReorder={(e) => this.onColumnReorder(e)}
								selection={this.state.selectedUser}
								onSelectionChange={this.selectUserRow}
								sortField={sortField}
								sortOrder={sortOrder}
								onSort={this.onSort}>
								{buildColumnOptions()}
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count'>Total records: {this.state.totalCount}</div>
						</div>
					</div>
				</LoadingIndicator>

				{this.state.openDrawers.inviteUser && (
					<InviteUserDrawer
						subscriptionId={this.props.subscriptionId.toString()}
						onComplete={this.onInviteUserComplete}
						onCancel={this.onInviteUserCancel}
					/>
				)}
				{this.state.openDrawers.userProfile && this.state.editUser && (
					<UserProfileDrawer
						subscriptionId={this.props.subscriptionId.toString()}
						userId={this.state.editUser.id.toString()}
						onComplete={this.onEditUserComplete}
						onCancel={this.onEditUserCancel}
						menuButtons={cogMenuButtons}
					/>
				)}
				{this.state.openDrawers.locationAccess && this.state.editUser && (
					<UserLocationsDrawer
						subscriptionId={this.props.subscriptionId}
						onComplete={this.onEditLocationsComplete}
						onCancel={this.onEditLocationsCancel}
						user={this.state.editUser}
						menuButtons={cogMenuButtons}
						onBulkLocationSearchLaunch={this.onBulkLocationSearchLaunch}
					/>
				)}
				{this.state.openDrawers.bulkLocationSearch && this.state.editUser && (
					<UserBulkLocationSearchDrawer
						subscriptionId={this.props.subscriptionId.toString()}
						onComplete={this.onBulkLocationSearchComplete}
						onCancel={this.onBulkLocationSearchCancel}
						userFullName={this.state.editUser.firstName + ' ' + this.state.editUser.lastName}
						userId={this.state.editUser.id.toString()}
						menuButtons={cogMenuButtons}
						selectedLocations={this.state.assignedLocations}
					/>
				)}
				{this.state.openDrawers.emailSettings && this.state.editUser && (
					<UserNotificationsDrawer
						subscriptionId={this.props.subscriptionId}
						userId={this.state.editUser.id}
						userRole={this.state.editUser.roleName}
						userFullName={this.state.editUser.firstName + ' ' + this.state.editUser.lastName}
						onComplete={this.onEmailSettingsComplete}
						onCancel={this.onEmailSettingsCancel}
						menuButtons={cogMenuButtons}
					/>
				)}
				{this.state.showAllBaselinesModal && (
					<Modal
						id='allBaselines'
						title='Grant Access to all Baselines'
						body={
							<div>
								Are you sure you want to grant{' '}
								<strong>
									{this.state.editUser.firstName} {this.state.editUser.lastName}
								</strong>{' '}
								access to all baselines?
							</div>
						}
						onPrimaryClick={this.allBaselinesOk}
						onSecondaryClick={this.allBaselinesCancel}
						onCloseClick={this.allBaselinesCancel}
					/>
				)}
				{this.state.showReassignTasksModal && (
					<Modal
						id='reassignTasks'
						title={`${this.state.reassignMode === 'unassign' ? 'Unassign' : 'Reassign'} Tasks`}
						body={this.renderReassignTasksModalBody()}
						onPrimaryClick={
							this.state.reassignMode === 'reassign' && !this.state.selectedAssigneeUserId
								? undefined
								: this.onReassignTasksConfirm
						}
						onSecondaryClick={this.onReassignTasksCancel}
						onCloseClick={this.onReassignTasksCancel}
						primaryButtonText={this.state.reassignMode === 'unassign' ? 'Unassign Tasks' : 'Reassign Tasks'}
						secondaryButtonText="Cancel"
						isLoading={this.state.isLoadingTaskInfo || this.state.isSaving}
					/>
				)}
				{this.state.openDrawers.importUsers && (
					<ImportUsersDrawer
						subscriptionId={this.props.subscriptionId.toString()}
						onComplete={this.onImportUsersComplete}
						onCancel={this.onImportUsersCancel}
					/>
				)}
			</div>
		);
	}
}
SubscriptionUsersPage.propTypes = {
	userActions: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	accountActions: PropTypes.object.isRequired,
	subscriptionActions: PropTypes.object.isRequired,
	subscriptionId: PropTypes.string,
	windowWidth: PropTypes.number.isRequired,
	isSubPage: PropTypes.bool,
	onClose: PropTypes.func,
	mfaActions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
	let subscriptionId = null;
	if (ownProps.subscriptionId && ownProps.isSubPage) {
		subscriptionId = ownProps.subscriptionId.toString();
	} else if (ownProps.match.params.subscriptionId) {
		subscriptionId = ownProps.match.params.subscriptionId;
	}

	return {
		subscriptionId: subscriptionId,
		windowWidth: state.window.width,
		history: ownProps.history,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch),
		accountActions: bindActionCreators(accountActions, dispatch),
		subscriptionActions: bindActionCreators(subscriptionActions, dispatch),
		mfaActions: bindActionCreators(mfaActions, dispatch),
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubscriptionUsersPage));
